/**
 * ZRF-WTPB-004/006 — local template preview before Generate Links.
 * Stub `/p/t/pending-link/…` URLs are replaced by API `renderedBody` after
 * POST …/generate-links (hashed token-only paths).
 */

const STUB_TOKEN = 'pending-link';

export function getPortalStubBase() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/p/t/${STUB_TOKEN}`;
  }
  return `https://app.zenrentflow.com/p/t/${STUB_TOKEN}`;
}

/**
 * @param {string} body
 * @param {{
 *   propertyName?: string,
 *   tenantFirstName?: string,
 *   eventTitle?: string,
 *   eventDetails?: string,
 *   eventDate?: string,
 *   includeMaintenance?: boolean,
 *   includeAccess?: boolean,
 *   includeDocuments?: boolean,
 *   includePortalHome?: boolean,
 * }} vars
 */
export function renderCommunicationTemplate(body, vars = {}) {
  const base = getPortalStubBase();
  const maintenanceLink = vars.includeMaintenance === false
    ? ''
    : `${base}/maintenance/new`;
  const confirmAccessLink = vars.includeAccess === false
    ? ''
    : `${base}/access/confirm`;
  const documentsLink = vars.includeDocuments === false
    ? ''
    : `${base}/documents`;
  const portalHomeLink = vars.includePortalHome
    ? base
    : '';

  const map = {
    property_name: vars.propertyName || 'your property',
    tenant_first_name: vars.tenantFirstName || 'there',
    event_title: vars.eventTitle || '[event title]',
    event_details: vars.eventDetails || '[event details]',
    event_date: vars.eventDate || '[date]',
    maintenance_link: maintenanceLink || '[maintenance link — generate in 006]',
    confirm_access_link: confirmAccessLink || '[access link — generate in 006]',
    documents_link: documentsLink || '[documents link — generate in 006]',
    portal_home_link: portalHomeLink || '[portal link — generate in 006]',
  };

  let rendered = String(body || '');
  Object.entries(map).forEach(([key, value]) => {
    const pattern = new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'gi');
    rendered = rendered.replace(pattern, value);
  });

  // Drop lines that still only contain empty stub leftovers after opt-out
  if (vars.includeMaintenance === false) {
    rendered = rendered.replace(/^.*\[maintenance link[^\]]*\]\s*$/gim, '');
  }
  if (vars.includeAccess === false) {
    rendered = rendered.replace(/^.*\[access link[^\]]*\]\s*$/gim, '');
  }
  if (vars.includeDocuments === false) {
    rendered = rendered.replace(/^.*\[documents link[^\]]*\]\s*$/gim, '');
  }

  return rendered.replace(/\n{3,}/g, '\n\n').trim();
}

export function isGroupUnsafeTemplate(template) {
  if (!template) return false;
  return template.groupSafe === false || template.requiresPrivateChannel === true;
}
